import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {format, isMatch, addMonths} from 'date-fns';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import DatePicker from "react-datepicker";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import BreadCrumbNav from '../BreadCrumbNav';
import { getUser,getFilterOptions } from '../../helpers';
import Chart from 'react-google-charts';
import './WorkHistoryStatus.css'
import { Container } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import { Button } from '@material-ui/core';

const active_Time_ex = '-';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'red',
    maxWidth: 270,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

class WorkHistoryStatus extends Component {
  _isMounted = false; 
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 50,
      date: null,
      user_name: null,
      user_id: null,
      pc: {},
      startDate: new Date(),
      endDate: new Date(),
      startDateValid: false,
      firstLoad: true,
      // test:true,
    };
  }

  checkTextValid(text) {
    return text !== null && text !== undefined;
  }

  fetchWorkHistories(offset, startDate, endDate, mac_add = undefined) {
    const { getWorkHistories, clearWorkHistoriesStatus } = this.props
    const params = {
      offset: offset * this.state.limit,
      limit: this.state.limit,
      date: format(Date.now(), 'yyyy-MM-dd'),
      startDate: startDate ? format(startDate, 'yyyy-MM-dd') : "",
      endDate: format(endDate, 'yyyy-MM-dd'),
    };
    if (mac_add !== null) { // 端末番号
      params.mac_add = mac_add !== undefined ? mac_add : this.state.pc.mac_add;
    }
    // if (this.checkTextValid(params.user_name)  && (params.mac_add)){
    if (params.mac_add){
      getWorkHistories(params);
    }
    else{
      clearWorkHistoriesStatus();
    }
  
    if (this._isMounted) {
      this.setState({ offset, endDate });
      if (startDate) {
        this.setState({ startDateValid: true, startDate });
      }
    }

  }

  fetchFilter() {
    const { getFilterDatas } = this.props;
    // const params = {
    //   startDate: startDate ? format(startDate, 'yyyy-MM-dd') : "",
    //   endDate: format(endDate, 'yyyy-MM-dd'),
    // };
    const params = {
      filter_items: ["user_master_history"]
    };
    getFilterDatas(params);
  }

  componentDidMount() {
    this._isMounted = true; 
    let startDate = undefined;
    let endDate = new Date();
    let c = new Date();
    // c.setDate(c.getDate() - 365);
    // console.log(c);
    // 検索期間デフォルト：前月1日～現在まで
    c = addMonths(c, -1);
    c.setDate(1);
    startDate = new Date(c);
    endDate = new Date();

    this.fetchWorkHistories(this.state.offset, startDate, endDate, null);
    this.fetchFilter();
  }

  componentWillUnmount() {
    this._isMounted = false; 
  }

  //稼働時間を表示するのに関数
  ShowTheTime = (Time_show = []) => {
    let rows = [];
    for (let i = 0; i < Time_show.length; i++) {
      if (Time_show[i] === 'error'||Time_show[i] === 'エラー') {
        Time_show[i] = 'エラー';
        rows.push(<HtmlTooltip
          key={i}
          title={
            <React.Fragment>
              <Typography color="error">起動または終了時間が取得できて<br/>いないデータがあります。</Typography>
            </React.Fragment>
          }
        >
          <div style={{ color: "red"}}>{Time_show[i]}</div>
        </HtmlTooltip>)
      }
      else {
        const isValidDate = isMatch(Time_show[i], 'yyyy-MM-dd HH:mm:ss');
        if (isValidDate) {
          const formattedDate = format(new Date(Time_show[i]), 'HH:mm:ss');
          rows.push(<div key={i}>{formattedDate}</div>);
        } else {
          rows.push(<div key={i}>{Time_show[i]}</div>);
        }
        
      }
    }
    return rows;
  };

  //稼働終了時間を表示するのに関数
  ShowShutdownTime = (Time_show = [], bootSystemTime = []) => {
    let rows = [];
    for (let i = 0; i < Time_show.length; i++) {
      if (Time_show[i] === 'error'||Time_show[i] === 'エラー') {
        Time_show[i] = 'エラー';
        rows.push(<HtmlTooltip
          key={i}
          title={
            <React.Fragment>
              <Typography color="error">起動または終了時間が取得できて<br/>いないデータがあります。</Typography>
            </React.Fragment>
          }
        >
          <div style={{ color: "red"}}>{Time_show[i]}</div>
        </HtmlTooltip>)
      }
      else {
        // const isValidShutdownDate = isMatch(Time_show[i], 'HH:mm:ss');
        const isValidShutdownDate = isMatch(Time_show[i], 'yyyy-MM-dd HH:mm:ss');
        const isValidBootSystemDate = isMatch(bootSystemTime[i], 'yyyy-MM-dd HH:mm:ss');

        let bShutdownTimeErr = false;
        if (isValidShutdownDate && isValidBootSystemDate) {
          const dtShutdown = new Date(Time_show[i]);
          const dtBootSystem = new Date(bootSystemTime[i]);
          if (dtShutdown < dtBootSystem) {
            bShutdownTimeErr = true;
          }
        }
        if (bShutdownTimeErr) {
          rows.push(<HtmlTooltip
            key={i}
            title={
              <React.Fragment>
                <Typography color="error">起動時間が終了時間より未来の<br/>データがあります。<br/>起動時間：{bootSystemTime[i]}<br/>終了時間：{Time_show[i]}</Typography>
              </React.Fragment>
            }
          >
            <div style={{ color: "red"}}>エラー</div>
          </HtmlTooltip>)
        } else {
          if (isValidShutdownDate) {
            const formattedDate = format(new Date(Time_show[i]), 'HH:mm:ss');
            rows.push(<div key={i}>{formattedDate}</div>);
          } else {
            rows.push(<div key={i}>{Time_show[i]}</div>);
          }
        }
      }
    }
    return rows;
  };

  //終了時間のエラーをチェックするのに関数
  CheckErrorTimeShutdown = (Time_ShutDown = [], bootSystemTime = []) => {
    let CheckError = false;
    for (let i = 0; i < Time_ShutDown.length; i++) {
      if (Time_ShutDown[i] === 'error'||Time_ShutDown[i] === 'エラー') {
        CheckError = true;
      } else {
        const isValidShutdownDate = isMatch(Time_ShutDown[i], 'yyyy-MM-dd HH:mm:ss');
        const isValidBootSystemDate = isMatch(bootSystemTime[i], 'yyyy-MM-dd HH:mm:ss');
        if (isValidShutdownDate && isValidBootSystemDate) {
          const dtShutdown = new Date(Time_ShutDown[i]);
          const dtBootSystem = new Date(bootSystemTime[i]);
          if (dtShutdown < dtBootSystem) {
            CheckError = true;
          }
        }
      }
    }
    return CheckError;
  };


  //時間を取得するに関数
  fncTimeToNumber = (Time = [], active_Time) => {
    let datatime_g = [];
    if (Time.length === 0) {
      Time = ['00:00:00'];
    }
    for (var n = 0; n < Time.length; n++) {
      if (Time[n] === '-' && active_Time !== '-') {
        Time[n] = '24:00:00';
      }
      let time_Number_arr = Number(((Number(String(Time[n]).substring(0, 2)) + Number(String(Time[n]).substring(3, 5)) / 60)).toFixed(2))
      datatime_g.push(time_Number_arr);
    }
    return datatime_g;
  }


  splitArrayData=(Arraydata= [],pageNumber) =>{
    // console.log("データをロードする");
    let lenArray =Arraydata.length;
    let returnArray=[];
    let startIndex= pageNumber*this.state.limit;
    let endIndex= ((pageNumber+1) * this.state.limit)-1;
    
    if (lenArray===0 || lenArray<=startIndex)
      return returnArray
    if (lenArray <=endIndex)
      endIndex=lenArray-1;
    for (var index = startIndex; index <= endIndex; index++) {
      returnArray.push(Arraydata[index]);
      }
    return returnArray
  }

  //APIからデータを取得するデータ関数
  fncGraphData = (arrStart = [], arrEnd = []) => {
    arrStart = arrStart.reverse();
    arrEnd = arrEnd.reverse();
    let arr_0 = [];
    let arr_1 = [''];
    for (var n = 0; n < arrStart.length * 2 + 1; n++) {
      arr_0.push('');
    }
    let data = [arr_0];
    for (var i = 0; i < arrStart.length; i++) {
      (i === 0) ? arr_1.push(arrStart[i]) : arr_1.push(arrStart[i] - arrEnd[i - 1]);
      (i === 0) ? arr_1.push((arrEnd[i] - arrStart[i])) : arr_1.push(arrEnd[i] - arrStart[i]);
    }
    for (var k = 0; k < 1; k++) {
      data.push(arr_1);
    }
    return data;
  }

  handleClickDownloadCSV = () => {

    const filteredData = this.props.items.detailData.filter(item =>
      (!this.state.pc_name || (item.pc_name && item.pc_name.includes(this.state.pc_name))) 
    );

    const csvRows = ["検索条件："]; 
    csvRows.push("　期間: " + format(this.state.startDate, 'yyyy/MM/dd') + "～" + format(this.state.endDate, 'yyyy/MM/dd'));
    
    if (this.state.user_name === null) {
      csvRows.push("　ユーザー名: すべて");
    } else if (this.state.user_name === "") {
      csvRows.push("　ユーザー名: 空白");
    } else {
      csvRows.push("　ユーザー名: " + this.state.user_name);
    };
  
    if (this.state.pc.pc_name === null) {
      csvRows.push("　端末番号: すべて");
    } else if (this.state.pc.pc_name === "") {
      csvRows.push("　端末番号: 空白");
    } else {
      csvRows.push("　端末番号: " + this.state.pc.pc_name);
    };
  
    const csvHeaderTitles = ["日付", "起動時間", "終了時間"];

    csvRows.push([csvHeaderTitles.join(',')]);
    
    const formatTimeForCSV = (Time_show = []) => {
      let formattedTimes = [];
      for (let i = 0; i < Time_show.length; i++) {
        if (Time_show[i] === 'error' || Time_show[i] === 'エラー') {
          formattedTimes.push("エラー"); 
        } else {
          const isValidDate = isMatch(Time_show[i], 'yyyy-MM-dd HH:mm:ss');
          if (isValidDate) {
            formattedTimes.push(format(new Date(Time_show[i]), 'HH:mm:ss'));
          } else {
            formattedTimes.push(Time_show[i]); 
          }
        }
      }
      return formattedTimes.join(" "); 
    };
    
    filteredData.forEach(item => {
      const row = [
        item.strDateTime,
        `\t${formatTimeForCSV(item.start_time_show)}`,
        `\t${formatTimeForCSV(item.shutdown_time_show)}`,
      ];
      
      csvRows.push(row.map(v => `"${v.toString().replace(/"/g, '""')}"`).join(','));
    });
  
    const csvData = csvRows.join('\n');
    const BOM = '\uFEFF'; // BOM cho UTF-8
    const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });

    const date = new Date();
    const options = {
      timeZone: "Asia/Tokyo",
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, ''); 
    const filename = `稼働状況確認_${formattedDate}.csv`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const user = getUser();
    let { items, filterDatas, isFetching, totalRows, startDate} = this.props

    const changePagination = (event, val) => {
      console.log(val);
      this.setState({ offset: val - 1 });
      this.setState({ firstLoad: false });
    };

    const handleChangeFilter = (filterName, value) => {
      let { user_name, user_id, pc } = this.state;
      // const filterValue = value;

      this.setState({ firstLoad: false });

      // const obj = {};
      // obj[filterName] = filterValue;
      if (filterName === "user_name") {
        // ユーザー名
        user_name =value? value.name:"";
        user_id = value? value.i_num:null;
        this.setState({ user_name: user_name, user_id: user_id }); // 2021.11.01

        // 端末番号
        pc = {};
        let pc_options=value? value.pc_list:null;
        if (pc_options && pc_options.length === 1) {
            pc = pc_options[0];
          }
        this.setState({ pc }); // 2021.11.01
      }

      if (filterName === "pc_name"  ) {
        // 端末番号
        pc = value || {};
        this.setState({ pc }); // 2021.11.01
      }

      // データFETCH
      this.fetchWorkHistories(0, this.state.startDateValid ? this.state.startDate : new Date(startDate), this.state.endDate,
        pc.mac_add || null);
    };

    const handleChangeStartDate = (date) => {
      console.log(date);
      const diffDateTime =(this.state.endDate - date)/(1000*60*60*24);
      if (diffDateTime < 0){
        window.alert(`開始日付より終了日付が未来になるように設定ください。`);
        return false;
      }
      if (this.state.mac_add === null && this.state.user_id === null) {
        this.setState({ startDate: date });
        console.log("日付が変更できない。");
      } else {
        this.setState({ firstLoad: false });
        // 稼働履歴取得
        this.fetchWorkHistories(0, date, this.state.endDate);
      }
    };

    const handleChangeEndDate = (date) => {
      if (this.state.mac_add === null && this.state.user_id === null) {
        this.setState({ endDate: date });
        console.log("日付が変更できない。");

      } else {
        this.setState({ firstLoad: false });
        // 稼働履歴取得
        this.fetchWorkHistories(0, this.state.startDateValid ? this.state.startDate : new Date(startDate), date);
      }

    };

    const setUserOptions = () => {
      if (!filterDatas || !filterDatas.user_master_history){return [];}

      let options = filterDatas.user_master_history;
      // ユーザー名
      options=getFilterOptions(options,["i_num","name","pc_list"],"i_num","name")
                  .sort((a, b) => a.name.localeCompare(b.name, undefined, {sensitivity: "base", numeric: true}));

      return options;
    };

    const setPcOptions =(userOptions)=>{
      let pcOptions=[];
      if (this.state.user_id && userOptions) {
        const user = userOptions.find(
          item => item.i_num === this.state.user_id
        );
    
        if (user) {
          pcOptions = [...user.pc_list].sort((a, b) =>
            (a.pc_name || "").localeCompare(b.pc_name || "", undefined, {
              sensitivity: "base",
              numeric: true
            })
          );
        }
      }

      return pcOptions;
    }

    // フィルターデータ設定
    let userOptions=setUserOptions();
    let pcOptions=setPcOptions(userOptions);

    return (
      <div className="workhistory-container">
        {this.state.firstLoad && isFetching ? <div className='loading'>お待ちください．．．</div>
          : <>
            <BreadCrumbNav screenName="稼働状況確認"></BreadCrumbNav>
            <div className="loginname">ログイン名：{user.username}</div>
            <div className="workhistory-filter">

            <FormControl variant="outlined" className="workhistory-filter__item">
                <InputLabel className="filter-label">期間：</InputLabel>
                <div className="workhistory-daterange">
                  <DatePicker
                    className="date-picker"
                    selected={!this.state.startDateValid && startDate ? new Date(startDate) : this.state.startDate}
                    onChange={(date) => handleChangeStartDate(date)}
                    selectsStart
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    dateFormat="yyyy/MM/dd"
                    minDate={this.state.startDateValid ? new Date(this.state.endDate.getFullYear() - 1, this.state.endDate.getMonth(), this.state.endDate.getDate()) : {}}
                  />
                  <div className="date-picker">〜</div>
                  <DatePicker
                    className="date-picker"
                    selected={this.state.endDate}
                    onChange={(date) => handleChangeEndDate(date)}
                    selectsEnd
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    minDate={!this.state.startDateValid && startDate ? new Date(startDate) : this.state.startDate}
                    maxDate={new Date(this.state.startDate.getFullYear() + 1, this.state.startDate.getMonth(), this.state.startDate.getDate())}
                    dateFormat="yyyy/MM/dd"
                  />
                </div>
              </FormControl>

              <FormControl className="formhistory-filter">
                <Autocomplete
                  freeSolo
                  /* disableClearable */
                  id="combo-box-autocomplete-user_name"
                  className="combo-box-autocomplete-status"
                  value={this.state.user_name}
                  onChange={(event, newValue) => {
                    console.log("onChange", newValue);
                    handleChangeFilter("user_name", newValue);
                  }}
                  onInputChange={(e, value) => {
                    if (e && e.type === "change") {
                      console.log("onInputChange", value);
                      // this.setState({ firstLoad: false, user_name: value, user_id: undefined });
                      // this.fetchWorkHistories(0,
                      //   this.state.startDateValid ? this.state.startDate : new Date(startDate),
                      //   this.state.endDate,
                      //   value,
                      //   this.state.pc_name,
                      //   this.state.pc.mac_add);
                    }
                  }
                  }
                  options={userOptions}
                  getOptionLabel={(option) => 
                    typeof option === 'string' ? option : option?.name || ''
                  }
                  renderInput={(params) =>
                    <TextField
                      {...params}
                      className="autocomplete-filter"
                      label="ユーザー名："
                      variant="outlined"
                      fullWidth
                    />
                  }
                />
              </FormControl>

              <FormControl className="formhistory-filter">
                <Autocomplete
                  freeSolo
                  disableClearable
                  id="combo-box-autocomplete-pc_name"
                  className="combo-box-autocomplete-status"
                  value={this.state.pc}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    handleChangeFilter("pc_name", newValue);
                  }}
                  onInputChange={(e, value) => {
                    if (e && e.type === "change") {
                      this.setState({ firstLoad: false, pc_name: value.pc_name, mac_add: undefined });
                      // this.fetchWorkHistories(0,
                      //   this.state.startDateValid ? this.state.startDate : new Date(startDate),
                      //   this.state.endDate,
                      //   this.state.user_name,
                      //   this.state.selected_user_name,
                      //   value.mac_add);
                    }
                  }
                  }
                  options={pcOptions}
                  getOptionLabel={(option) => option.pc_name || ""}
                  renderInput={(params) =>
                    <TextField
                      {...params}
                      className="autocomplete-filter"
                      label="端末番号："
                      variant="outlined"
                      fullWidth
                    />
                  }
                  disabled = {!this.checkTextValid(this.state.user_name) && !this.checkTextValid(this.state.user_id)}
                />
              </FormControl>

              <FormControl className="formhistory-filter">
              <Collapse in={!this.checkTextValid(this.state.user_name) || !this.state.pc.mac_add}>
                <Alert style={{height:'40px', padding: '2px 10px 0 10px'}} variant="filled" severity="info" color="info">
                  検索条件を設定してください。
                </Alert>
                </Collapse>
              </FormControl>

              <FormControl className="WorkHistoryStatus-download">
              <Button
                variant="contained"
                color="primary"
                className="download-button"
                onClick={this.handleClickDownloadCSV}
                disabled={!this.props.items || this.props.items.length === 0}
              >
                ダウンロード
              </Button>
            </FormControl>

            <div className='historystatus-item-count'>
              <b> 検索結果：{totalRows}件 </b>  
            </div>

            </div>

            <Box sx={{ width: '100%', height: '2px' }}>
              {isFetching && <LinearProgress />}
            </Box>

            <Paper className="table-root">
              <TableContainer className="workhistorystatus-table-container">
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" style={{ minWidth: 180 }}>日付</TableCell>
                      {/* <TableCell align="center" style={{ minWidth: 180 }}>ユーザー名</TableCell>
                      <TableCell align="center" style={{ minWidth: 140 }}>端末番号</TableCell> */}
                      <TableCell align="center" style={{ minWidth: 120 }}>起動時間</TableCell>
                      <TableCell align="center" style={{ minWidth: 120 }}>終了時間</TableCell>
                      <TableCell align="center" style={{ minWidth: 500 }}>稼働状態</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items && (this.splitArrayData(items.detailData, this.state.offset) || []).map((item, index) => (
                      <TableRow key={index}>
                        {(this.CheckErrorTimeShutdown(item.shutdown_time_show, item.start_time_show)) ?
                          <TableCell align="center" component="th" scope="row" style={{ color: 'red', fontWeight: 'bold' }}>{item.strDateTime}</TableCell> :
                          <TableCell align="center" component="th" scope="row">{item.strDateTime}</TableCell>
                        }
                        {/* <TableCell align="center">{item.user_name}</TableCell>
                        <TableCell align="center">{item.pc_name}</TableCell> */}
                        <TableCell align="center">{this.ShowTheTime(item.start_time_show)}</TableCell>
                        <TableCell align="center">{this.ShowShutdownTime(item.shutdown_time_show, item.start_time_show)}</TableCell>
                        <TableCell align="center">
                          <Container align="center" style={{ Width: "100%", Height: "100%" }}>

                            { this._isMounted &&
                              <Chart
                                width="700px"
                                /*Edit Start 2023/05/25 - ウェン*/
                                /*height="120px"*/
                                height="70px"
                                /*Edit End 2023/05/25 - ウェン*/
                                chartType="BarChart"
                                loader={<div>Loading Chart</div>}
                                data={this.fncGraphData(this.fncTimeToNumber(item.start_time_value, active_Time_ex), this.fncTimeToNumber(item.shutdown_time_value, active_Time_ex))}
                                options={{
                                  'chartArea': {
                                    left: "7",
                                    right: "7",
                                    top: "2%",
                                    width: '100%',
                                    height: '75%'
                                  },
                                  isStacked: true,
                                  enableInteractivity: false,
                                  hAxis: {
                                    count: 24,
                                    viewWindow: {
                                      max: 24,
                                      min: 0,
                                    },
                                    /* ticks: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24], */
                                    gridlines: {
                                      color: '#8c8e91',
                                      minSpacing: 40,
                                    },
                                    baselineColor: '#8c8e91',

                                  },
                                  colors: ['transparent', '#009933'],
                                  legend: { position: 'none' },
                                  bar: { groupWidth: "100%" }
                                }}
                                rootProps={{ 'data-testid': '1' }}
                              />
                            }
                          </Container>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {totalRows > 0 && <div className='pagination-button'>
                <Pagination page={this.state.offset + 1} count={Math.ceil(parseInt(totalRows) / this.state.limit)} onChange={changePagination} color="primary" variant="outlined" shape="rounded" showFirstButton showLastButton />
              </div>
              }
            </Paper>
          </>
        }
      </div>
    );
  }
}

WorkHistoryStatus.propTypes = {
  getWorkHistories: PropTypes.func.isRequired,
  getFilterDatas: PropTypes.func.isRequired,
};

export default WorkHistoryStatus;